import * as amplitude from "@amplitude/analytics-browser"

import { sendEventToOptimizely } from "./analytics-optimizely"

export default async function analyticsAction(
  action: string,
  data: Record<string, any> = {}
) {
  sendEventToOptimizely("marketing_action", { Action: action })

  await amplitude.track("Marketing Action", {
    Action: action,
    ...data,
  }).promise
}
